import { useEffect, useRef } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { roiPreview3DOpenState } from '~/state/atoms/viewerAtoms';

/** Switch the 3-D structure preview on while mounted, then put it back the way it was found. */
export function useCrossSectionPanelAutoOpen(): void {
    const isOpen = useRecoilValue(roiPreview3DOpenState);
    const setIsOpen = useSetRecoilState(roiPreview3DOpenState);
    const wasOpenRef = useRef<boolean | null>(null);
    if (wasOpenRef.current === null) {
        wasOpenRef.current = isOpen;
    }
    useEffect(() => {
        setIsOpen(true);
        return () => {
            if (wasOpenRef.current === false) {
                setIsOpen(false);
            }
        };
    }, [setIsOpen]);
}
